














































import Vue from 'vue';
import { defineComponent, ref, watch, computed } from '@vue/composition-api';
import { generateRandomId } from '../helpers';
import { useWrapperClasses, useInputClasses } from './abstractions';

export default defineComponent({
    name: 'WokSelectNative',

    props: {
        name: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'string',
            validator: (v: string) => /(string|number|boolean)/.test(v)
        },
        value: {
            type: [String, Number, Boolean],
            default: ''
        },
        label: {
            type: String,
            dafault: ''
        },
        error: {
            type: Object,
            default: null
        },
        placeholder: {
            type: String,
            default: ''
        },
        placeholderValue: {
            type: [String, Number, Boolean],
            default: null
        },
        disabled: {
            type: [Boolean, String],
            default: false
        },
        readonly: {
            type: [Boolean, String],
            default: false
        },
        options: {
            type: Array,
            default: null
        }
    },

    model: { prop: 'value', event: 'update:value' },

    setup(props, context) {

        const id = generateRandomId(props.name);

        const convertedValue = computed(() => props.value && props.value.toString() || '');

        const isReadOnly = computed(() => props.readonly.toString() == 'true');

        const isDisabled = computed(() => props.disabled.toString() == 'true');

        const onChange = (evt: Event) => {
            const c = (v: string) => {
                if (props.type == 'number') {
                    var result = parseInt(v);
                    if (isNaN(result)) {
                        return null;
                    }
                    return result;
                }
                else if (props.type == 'boolean') {
                    if (v == '') {
                        return null;
                    }
                    return v == 'true' ? true : false;
                }
                else {
                    if (props.placeholder) {
                        // If a placeholder is present the empty string is returned as null.
                        return v || null;
                    }
                    // Else we return just `v`: this allows for using the empty string as value.
                    return v;
                }
            }
            if (evt.target instanceof HTMLSelectElement) {
                context.emit('update:value', c(evt.target.value));
            }
        }

        return {
            id,
            wrapperClasses : useWrapperClasses(props, context.attrs),
            inputSelectClasses : useInputClasses('select-native'),
            inputTextClasses : useInputClasses('text'),
            convertedValue,
            isReadOnly,
            isDisabled,
            onChange
        }
    }
})
